"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _SvgIcon = require("material-ui/SvgIcon");

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OpenDefecation = function OpenDefecation(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    (0, _extends3.default)({ viewBox: "0 0 24 24", className: "custom-icon" }, props),
    _react2.default.createElement("path", {
      d: "M9.62395119,20.8754243 L6.89585899,17.3059579 L11.5361653,18.7592406 C12.2245624,18.8612254 12.9639519,18.810233 13.2699062,18.5807673 C16.0744869,16.5410722 15.8705174,10.4219869 9.64944738,5.19526824 C8.75708077,4.43038257 7.40578277,4.76183303 6.81937043,5.24626061 C6.81937043,5.24626061 6.81937043,5.24626061 6.53891235,5.60320726 L2.68898785,11.110384 C2.45952215,10.9319107 2.15356789,10.8554221 1.84761362,10.8809183 C1.18471272,10.9574069 0.70028513,11.5438192 0.776773697,12.2067201 L0.90425464,13.2520639 C0.955247018,13.6345067 1.15921653,13.9659572 1.49066698,14.1444305 C1.38868223,14.6033619 1.51616317,15.1132857 1.87310981,15.5212247 L6.61540092,20.8754243 L8.70608839,23.1955775 C9.1395236,23.6800051 9.85341688,23.7055013 10.2868521,23.3230584 C10.5928064,23.0426003 10.3842306,21.9075967 10.2868521,21.6913023 C10.0348116,21.3633792 9.81384468,21.0914198 9.62395119,20.8754243 Z M7.96669892,8.61175753 C9.1395236,10.9064145 9.80242451,12.4871782 10.0318902,14.3229038 L4.11677442,13.0480944 L7.96669892,8.61175753 Z M4.11677442,6.01114628 C2.53968492,6.01114628 1.26120128,4.73266263 1.26120128,3.15557314 C1.26120128,1.57848364 2.53968492,0.3 4.11677442,0.3 C5.69386392,0.3 6.97234756,1.57848364 6.97234756,3.15557314 C6.97234756,4.73266263 5.69386392,6.01114628 4.11677442,6.01114628 Z",
      id: "path-1"
    })
  );
};

exports.default = OpenDefecation;


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/custom-icons/opendefecation.js
// module id = 2010
// module chunks = 1137